import type { ModerationState } from '@/features/moderation/types'

/** Ключи черновика, в которых лежит EN-перевод (имена — как в теле `PATCH`, контракт §4a). */
const TRANSLATION_DRAFT_KEYS = ['contentEn', 'titleEn'] as const

/** Перевод живой статьи лежит в черновике: читатели увидят его только после «Обновить».
 *  Единый признак для тоста завершения перевода и подсказки кнопки: «есть неотправленные
 *  правки» сам по себе ничего не говорит о переводе. */
export const translationInDraft = (state: ModerationState | null | undefined): boolean => {
  if (!state || state.visibility === 'unpublished' || !state.draft) return false
  const draft = state.draft
  return TRANSLATION_DRAFT_KEYS.some((key) => Object.prototype.hasOwnProperty.call(draft, key))
}
